import React, { useEffect, useState } from "react";
import s from "./Overview.module.scss";
import Card from "./Local Components/Cards/Card";
import LineCharts from "./Local Components/LineChart/index";
import PieCharts from "./Local Components/PieCharts/PieCharts";
import SelectField from "../../../../global components/Forms/SelectField/SelectField";
import Table from "./Local Components/Table";
import { UseAuthToken } from "../../../../libs/api/userSession";
import useSWR from "swr";
import { parseClientError, swrFetcher } from "../../../../libs/api/Endpoints";
import {
  revenueStat,
  sentMsgStat,
  totalMsgStat,
  userStats,
} from "../../../../libs/Utils/Types/Overview";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

import { Skeleton } from "antd";
import Unauthorised from "../../../../global components/Unauthorised";
dayjs.extend(duration);
type cardType = "users" | "msgSent" | "";

function Overview() {
  const token = UseAuthToken();
  const [filter, setFilter] = useState<string>("7");

  const [totalUsersUnauthorised, setTotalUsersUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);

  const [msgSentUnauthorised, setMsgSentUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);

  const [totalRevUnauthorised, setTotalRevUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);
  const [totalMsgUnauthorised, setTotalMsgUnauthorized] = useState<
    boolean | { title: string; message: string }
  >(false);

  const [cardFilter, setCardFilter] = useState<{
    type: cardType;
    value: string;
  }>({ type: "", value: "" });
  function handleFilter(value: string) {
    setFilter(value);
  }

  const {
    data: totalUsers,
    isLoading: loadingUsers,
    error: totalUsersError,
  } = useSWR<{ data: userStats }, any, any>(
    token
      ? [
          "api/admin/overview/users",
          token,
          {
            durationInDays: cardFilter.type === "users" ? cardFilter.value : "7",
          },
        ]
      : null,
    swrFetcher,
  );

  const {
    data: msgSent,
    isLoading: loadingMsgSent,
    error: msgSentError,
  } = useSWR<{ data: sentMsgStat }, any, any>(
    token
      ? [
          "api/admin/overview/messages",
          token,
          {
            durationInDays:
              cardFilter.type === "msgSent" ? cardFilter.value : "7",
          },
        ]
      : null,
    swrFetcher,
  );

  const {
    data: totalRev,
    isLoading: loadingTotalRev,
    error: totalRevError,
  } = useSWR<
    { data: revenueStat[]; meta: { duration: number; total: string } },
    any,
    any
  >(
    token
      ? ["api/admin/overview/revenue", token, { durationInDays: filter }]
      : null,
    swrFetcher,
  );

  const {
    data: totalMsg,
    isLoading: loadingTotalMsg,
    error: totalMsgError,
  } = useSWR<{ data: totalMsgStat }, any, any>(
    token ? ["api/admin/overview/message-stats", token] : null,
    swrFetcher,
  );
  const totalMessages =
    totalMsg &&
    totalMsg.data.map((item) => ({
      name: item.type,
      value: item.count,
    }));
  const data =
    totalRev &&
    totalRev.data.map((item) => ({
      name:
        filter === "31"
          ? dayjs(item.date).format("D") // Format as day of the month (1, 2, ..., 31)
          : filter === "365"
            ? dayjs(item.date).format("MMM") // Format as month (01, 02, ..., 12)
            : filter === "7"
              ? dayjs(item.date).format("dddd") // Format as the day of the week (Monday, Tuesday, ...)
              : dayjs(item.date).format("dddd"), // Default to day of theweek
      uv: item.total, // Y-axis key
    }));
  useEffect(() => {
    if (totalUsersError) {
      const e = parseClientError(totalUsersError);
      console.log("totalUsers", e);

      if (e.statusCode === 403) {
        setTotalUsersUnauthorized(true);
      } else {
        setTotalUsersUnauthorized({
          title: "Error!",
          message:
            e.message.charAt(0).toUpperCase() + e.message.slice(1) ||
            "Something went wrong",
        });
      }
    }

    if (msgSentError) {
      const e = parseClientError(msgSentError);
      console.log("msgSentError", e);

      if (e.statusCode === 403) {
        setMsgSentUnauthorized(true);
      } else {
        setMsgSentUnauthorized({
          title: "Error!",
          message:
            e.message.charAt(0).toUpperCase() + e.message.slice(1) ||
            "Something went wrong",
        });
      }
    }

    if (totalRevError) {
      const e = parseClientError(totalRevError);
      console.log("totalRevError", e);

      if (e.statusCode === 403) {
        setTotalRevUnauthorized(true);
      } else {
        setTotalRevUnauthorized({
          title: "Error!",
          message:
            e.message.charAt(0).toUpperCase() + e.message.slice(1) ||
            "Something went wrong",
        });
      }
    }
    if (totalMsgError) {
      const e = parseClientError(totalMsgError);
      console.log("totalMsgError", e);

      if (e.statusCode === 403) {
        setTotalMsgUnauthorized(true);
      } else {
        setTotalMsgUnauthorized({
          title: "Error!",
          message:
            e.message.charAt(0).toUpperCase() + e.message.slice(1) ||
            "Something went wrong",
        });
      }
    }
  }, [msgSentError, totalMsgError, totalRevError, totalUsersError]);
  return (
    <div className={s.wrapper}>
      <h2>Welcome!</h2>
      <div className={s.cards}>
        {totalUsersUnauthorised || msgSentUnauthorised ? (
          typeof totalUsersUnauthorised === "boolean" ||
          typeof msgSentUnauthorised === "boolean" ? (
            <div className={s.cardError}>
              <Unauthorised />
            </div>
          ) : (
            <div className={s.cardError}>
              <Unauthorised
                error={{ message: "something went wrong", title: "Error!" }}
              />
            </div>
          )
        ) : (
          <>
            {loadingUsers ? (
              <Skeleton.Button
                className={s.card}
                rootClassName={s.card}
                shape="square"
                active={loadingUsers}
                size="large"
              />
            ) : (
              <Card
                type="users"
                handleStat={setCardFilter}
                growthInPercentage={totalUsers?.data.totalUsers.growthRate || 0}
                cardStat={totalUsers?.data.totalUsers.value || 0}
                cardTitle="Total users"
                filters={cardFilter.type === "users" && cardFilter.value}
              />
            )}
            {loadingUsers ? (
              <Skeleton.Button
                shape="square"
                active={loadingUsers}
                size="large"
                className={s.card}
                rootClassName={s.card}
              />
            ) : (
              <Card
                type="users"
                growthInPercentage={
                  totalUsers?.data.activeUsers.growthRate || 0
                }
                handleStat={setCardFilter}
                cardStat={totalUsers?.data.activeUsers.value || 0}
                cardTitle="Active users"
                filters={cardFilter.type === "users" && cardFilter.value}
              />
            )}
            {loadingMsgSent ? (
              <Skeleton.Button
                shape="square"
                size="large"
                className={s.card}
                active={loadingMsgSent}
                rootClassName={s.card}
              />
            ) : (
              <Card
                growthInPercentage={0}
                handleStat={setCardFilter}
                type="msgSent"
                cardStat={msgSent?.data.totalMessages || 0}
                cardTitle="Messages sent"
                filters={cardFilter.type === "msgSent" && cardFilter.value}
              />
            )}
            {loadingUsers ? (
              <Skeleton.Button
                shape="square"
                size="large"
                className={s.card}
                active={loadingUsers}
                rootClassName={s.card}
              />
            ) : (
              <Card
                cardStat={totalUsers?.data.verificationStats.pending || 0}
                cardTitle="Pending verification"
              />
            )}
          </>
        )}
      </div>
      <div className={s.charts}>
        {loadingTotalRev ? (
          <Skeleton.Button
            className={s.lineSkeleton}
            rootClassName={s.lineSkeleton}
            shape="square"
            active={loadingTotalRev}
            size="large"
          />
        ) : (
          <div className={s.lineChart}>
            <div className={s.chartHead}>
              <h4>Revenue</h4>
              <SelectField
                bordered
                wrapperClassname={s.SelectWrapper}
                value={filter}
                defaultValue={"7"}
                onChange={(value: any) => handleFilter(value)}
                style={{ width: "100%", height: "100%" }}
                options={[
                  { value: "7", label: "Last week" },
                  { value: "31", label: "Last month" },
                  { value: "365", label: "Last year" },
                ]}
              />
            </div>
            {totalRevUnauthorised ? (
              typeof totalRevUnauthorised === "boolean" ? (
                <>
                  <Unauthorised />
                </>
              ) : (
                <>
                  <Unauthorised error={totalRevUnauthorised} />
                </>
              )
            ) : (
              <div className={s.innerCart}>
                <span className={s.total}>
                  <h3>{totalRev?.meta.total}</h3>
                </span>
                <LineCharts data={data ? data : []} />
              </div>
            )}
          </div>
        )}
        {loadingTotalMsg ? (
          <Skeleton.Button
            className={s.pieSkeleton}
            rootClassName={s.pieSkeleton}
            shape="square"
            active={loadingTotalMsg}
            size="large"
          />
        ) : (
          <div className={s.pieChart}>
            <div className={s.title}>
              <h3>Messages sent</h3>
            </div>
            <div className={s.chart}>
              {totalMsgUnauthorised ? (
                typeof totalMsgUnauthorised === "boolean" ? (
                  <Unauthorised />
                ) : (
                  <Unauthorised error={totalMsgUnauthorised} />
                )
              ) : (
                <>
                  <PieCharts data={totalMessages ? totalMessages : []} />
                  <div className={s.items}>
                    {totalMsg &&
                      totalMsg?.data.map((item) => (
                        <>
                          <div className={s.item}>
                            <span
                              className={
                                item.type === "sms"
                                  ? s.smsLabel
                                  : item.type === "email"
                                    ? s.emailLabel
                                    : item.type === "voice"
                                      ? s.voiceLabel
                                      : item.type === "mms"
                                        ? s.mmsLabel
                                        : s.voiceCall
                              }
                            >
                              <p>{item.percentage}%</p>
                              <h5>
                                {item.type === "email"
                                  ? "Email"
                                  : item.type === "voice"
                                    ? "Voice"
                                    : item.type.toUpperCase().replace("_", " ")}
                              </h5>
                            </span>
                            <p className={s.value}>{item.count}</p>
                          </div>
                        </>
                      ))}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>

      <div>
        <Table />
      </div>
    </div>
  );
}

export default Overview;
